/* eslint react/jsx-indent: 0 */
/* eslint import/namespace: ['error', { allowComputed: true }] */
import React from 'react'
import _cx from 'classnames/bind'
import type { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import { connect } from 'react-redux'
import { Text, Grid, Icon, List, TutorialTooltip, hooks } from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import { CombinedListingType, useListingContext } from 'common/context/listing'
import PopupTooltip from '../../components/popupTooltip'
import * as statics from '../../statics'
import SectionPanel from '../../components/sectionPanel'
import { url } from '../../services/tps_formatter'
import getPrepareForAuctionContent, {
  PrepareForAuctionContent, // PrepareForAuctionList,
} from '../../utils/prepareForAuctionContent'
import { withModalHooks } from '../../hooks/useModalFeatures'
// @ts-ignore no types
import cls from './index.scss'
import { getSellerDeedTooltip } from './utils'
import DueDiligenceDocument from './dueDiligenceDocument'
import TitleStatus from './titleStatus'

const { DUE_DILIGENCE_CONTENT_MAP } = statics

const cx = _cx.bind(cls)

export const adWidth = (ad?: JSX.Element) => (!ad ? 0 : 6)

const isNotFCL = (listing: AuctionBlueprintOnlineReactiveArgs['listing']) => {
  return (
    listing.listing_configuration?.asset_type !==
    graph.enums.AssetType.Foreclosure
  )
}

export const isFCLMarketing = (listing: CombinedListingType): boolean =>
  listing.listing_configuration?.product_type ===
  graph.enums.ProductType.FclMarketing

type DueDiligenceItemType = {
  ad?: JSX.Element
  title: string
  icon: string
  text: JSX.Element | string
  sections?: JSX.Element[] | null
  elmId: string
}

const DueDiligenceItem = ({
  ad,
  title,
  icon,
  text,
  sections = [],
  elmId = 'due_diligence_item',
}: DueDiligenceItemType) => {
  // @ts-ignore toolkit is not typed
  const isMobile = hooks.useIsMobileHook() as boolean // eslint-disable-line
  return (
    <div>
      <div id={elmId} className={cx('nav-anchor')} />
      <Grid className={cx('diligence-row')} data-elm-id={elmId}>
        <Grid.Column computer={1} tablet={1} only='computer tablet'>
          <Icon
            data-elm-id={`${elmId}_icon`}
            size='big'
            iconStyle='light'
            name={icon}
          />
        </Grid.Column>
        <Grid.Column
          // @ts-ignore fix types or export from DS
          computer={15 - adWidth(ad)}
          // @ts-ignore fix types or export from DS
          tablet={15 - adWidth(ad)}
          mobile={16}
        >
          <Grid.Row>
            <Grid.Column width={16}>
              <Text
                data-elm-id={`${elmId}_title`}
                size={isMobile ? 'small' : 'big'}
                color={isMobile ? 'gray' : 'grayDark'}
                className={cx('diligence-title')}
              >
                {title}
              </Text>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <Text
                color='gray'
                size={isMobile ? 'tiny' : 'small'}
                className={cx('u-ml-3', 'u-mt-1')}
              >
                {text}
              </Text>
            </Grid.Column>
          </Grid.Row>
          {sections && sections.length > 0 && (
            <div className={cx('u-ml-3', { 'u-mt-2': isMobile })}>
              <Grid>
                <Grid.Row>
                  {sections.map((section, i) => (
                    <Grid.Column computer={5} tablet={5} mobile={16} key={i}>
                      {section}
                    </Grid.Column>
                  ))}
                </Grid.Row>
              </Grid>
            </div>
          )}
        </Grid.Column>
        {!!ad && (
          <Grid.Column
            // @ts-ignore fix types or export from DS
            computer={adWidth(ad)}
            // @ts-ignore fix types or export from DS
            tablet={adWidth(ad)}
            mobile={16}
            textAlign='center'
          >
            {ad}
          </Grid.Column>
        )}
      </Grid>
    </div>
  )
}

type CheckListItemType = {
  children: JSX.Element
  unchecked?: boolean
}

const CheckListItem = ({ children, unchecked }: CheckListItemType) => {
  // @ts-ignore toolkit is not typed
  const isMobile = hooks.useIsMobileHook() as boolean // eslint-disable-line
  return (
    <List.Item>
      <div className={cx('u-display-f', 'u-mt-2')}>
        <div className={cx('u-mr-2', 'u-ml-2')}>
          <Icon
            color='success'
            size='large'
            iconStyle='light'
            name='check'
            // @ts-ignore fix types or export from DS
            style={{ visibility: unchecked ? 'hidden' : '' }}
          />
        </div>
        <Text
          size={isMobile ? 'tiny' : 'large'}
          color={isMobile ? 'gray' : 'grayDark'}
        >
          {children}
        </Text>
      </div>
    </List.Item>
  )
}

const PrepareForAuction = ({ note, list }: PrepareForAuctionContent) => {
  // @ts-ignore toolkit is not typed
  const isMobile = hooks.useIsMobileHook() as boolean // eslint-disable-line

  return (
    <span>
      <Text
        size={isMobile ? 'tiny' : 'large'}
        color={isMobile ? 'gray' : 'grayDark'}
      >
        Use this checklist to guide you on what to bring to the auction, like
        payment information, important documents and other items.
      </Text>
      <Text
        className='u-mt-2'
        size={isMobile ? 'tiny' : 'large'}
        color={isMobile ? 'gray' : 'grayDark'}
      >
        <strong>Note:</strong> {note}
      </Text>
      <List>
        {list
          .map((listItem, i) => {
            if (typeof listItem === 'string') {
              return null
            }

            const { title, body, unchecked } = listItem
            return (
              <CheckListItem key={i} unchecked={unchecked}>
                <>
                  <strong>{title}</strong> {body}
                </>
              </CheckListItem>
            )
          })
          .filter(Boolean)}
      </List>
    </span>
  )
}
type DueDiligenceType = {
  isPropertyReportAvailable: boolean
  propertyInformationReport: string
  hidePIR: boolean
  toggleAuthModal: (modal: string) => void
}

const DueDiligence = ({
  isPropertyReportAvailable,
  propertyInformationReport,
  hidePIR,
  toggleAuthModal,
}: DueDiligenceType) => {
  // @ts-ignore toolkit is not typed
  const isMobile = hooks.useIsMobileHook() as boolean // eslint-disable-line
  const { listing } = useListingContext()
  const { dueDiligence } = listing.__computed__
  const { titleInsurancePaidBy } = dueDiligence
  const isTitleInsurancePaidBySeller = (titleInsurancePaidBy: string) => {
    return titleInsurancePaidBy === 'Seller'
  }
  const getTitleReports = () => {
    const { specialDocuments } = dueDiligence
    const TITLE_INSURANCE_TOOLTIP =
      "If you choose the Seller's closing company, the Seller will pay for title insurance. If you choose your own closing company, you are responsible for obtaining title insurance."
    const titleReports = [
      <TitleStatus
        title='Title Insurance Paid by'
        elmId='title_insurance'
        key='title_insurance'
        status={
          <span>
            {isTitleInsurancePaidBySeller(titleInsurancePaidBy) && (
              <Icon name='check circle' color='success' />
            )}
            {titleInsurancePaidBy}
          </span>
        }
        tooltipMessage={
          isTitleInsurancePaidBySeller(titleInsurancePaidBy)
            ? TITLE_INSURANCE_TOOLTIP
            : ''
        }
      />,
      <DueDiligenceDocument
        doc={specialDocuments.titleReport}
        elmId='preliminary_title_report'
        key='preliminary_title_report'
        disabled={!specialDocuments.titleReport}
        disabledTooltip={statics.DOCUMENT_NOT_FOUND}
        fallbackTitle='Preliminary Title Report'
      />,
    ]
    const { sellerDeedType } = dueDiligence
    isNotFCL(listing) &&
      titleReports.unshift(
        <TitleStatus
          title='Deed Type'
          status={<span>{sellerDeedType}</span>}
          elmId='deed_type'
          tooltipMessage={getSellerDeedTooltip(listing)}
        />
      )
    return titleReports
  }

  const getPurchaseAgreements = (): JSX.Element[] => {
    const { specialDocuments } = dueDiligence
    if (isNotFCL(listing)) {
      return [
        <DueDiligenceDocument
          key='purchase_agreement'
          doc={specialDocuments.purchaseAgreement}
          elmId='purchase_agreement'
          disabled={!specialDocuments.purchaseAgreement}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Purchase Agreement'
        />,
        <DueDiligenceDocument
          doc={specialDocuments.addendum}
          elmId='addendum_doc'
          key='addendum_doc'
          disabled={!specialDocuments.addendum}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Addendum'
        />,
      ]
    } else if (dueDiligence.isTPSOhio) {
      return [
        specialDocuments.noticeOfSale && (
          <DueDiligenceDocument
            doc={specialDocuments.noticeOfSale}
            elmId='notice_of_sale'
            key='notice_of_sale'
            fallbackTitle='Notice of Sale'
          />
        ),
        <DueDiligenceDocument
          doc={specialDocuments.legalDescription}
          elmId='legal_description'
          key='legal_description'
          disabled={!specialDocuments.legalDescription}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Legal Description'
        />,
        <DueDiligenceDocument
          doc={specialDocuments.termsAndConditions}
          elmId='sale_terms_and_conditions'
          key='sale_terms_and_conditions'
          disabled={!specialDocuments.termsAndConditions}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Sale Terms and Conditions'
        />,
      ].filter(Boolean) as JSX.Element[]
    } else {
      return [
        specialDocuments.noticeOfSale && (
          <DueDiligenceDocument
            doc={specialDocuments.noticeOfSale}
            elmId='notice_of_sale'
            key='notice_of_sale'
            fallbackTitle='Notice of Sale'
          />
        ),
        <DueDiligenceDocument
          doc={specialDocuments.sampleCertOfSale}
          elmId='cert_of_sale'
          key='cert_of_sale'
          disabled={!specialDocuments.sampleCertOfSale}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Sample Certificate of Sale'
        />,
        <DueDiligenceDocument
          doc={specialDocuments.sampleDeed}
          elmId='sample_deed'
          key='sample_deed'
          disabled={!specialDocuments.sampleDeed}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Sample Deed'
        />,
      ].filter(Boolean) as JSX.Element[]
    }
  }

  const getPropertyDocs = () => {
    const { specialDocuments } = dueDiligence
    const reviewPropertyDocs = [
      <DueDiligenceDocument
        doc={specialDocuments.additionalPropertyInfo}
        elmId='additional_property_information'
        key='additional_property_information'
        disabled={!specialDocuments.additionalPropertyInfo}
        disabledTooltip={statics.DOCUMENT_NOT_FOUND}
        fallbackTitle='Additional Property Information'
      />,
    ]

    isNotFCL(listing) &&
      reviewPropertyDocs.push(
        <DueDiligenceDocument
          doc={specialDocuments.propertyInspectionReport}
          elmId='property_inspection_report'
          disabled={!specialDocuments.propertyInspectionReport}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
          fallbackTitle='Property Inspection Report'
        />
      )

    const fclMarketing = listing.fcl_marketing || {}

    if (
      isFCLMarketing(listing) &&
      (fclMarketing.appraiser_uri || fclMarketing.clerk_of_court_uri)
    ) {
      reviewPropertyDocs.push(
        <div className={!isMobile ? 'u-mb-4 u-mt-4' : 'u-mb-2'}>
          {fclMarketing.appraiser_uri && (
            <div>
              <a
                data-elm-id='appraiser_link'
                className={cx('link')}
                // @ts-ignore tps_formatter file is untyped
                href={url.format(fclMarketing.appraiser_uri)} // eslint-disable-line
                target='_blank'
                rel='noreferrer'
              >
                <Icon
                  name='external-link'
                  iconStyle='regular'
                  size='small'
                  color='info'
                  elmId='appraiser_right_arrow'
                />
                Property Appraiser
              </a>
            </div>
          )}
          {fclMarketing.clerk_of_court_uri && (
            <div>
              <a
                data-elm-id='clerk_of_court_link'
                className={cx('link')}
                // @ts-ignore tps_formatter file is untyped
                href={url.format(fclMarketing.clerk_of_court_uri)} // eslint-disable-line
                target='_blank'
                rel='noreferrer'
              >
                <Icon
                  name='external-link'
                  iconStyle='regular'
                  size='small'
                  color='info'
                  elmId='clerk_of_court_right_arrow'
                />
                Clerk of Court
              </a>
            </div>
          )}
        </div>
      )
    }

    if (isPropertyReportAvailable && !hidePIR) {
      reviewPropertyDocs.unshift(
        <DueDiligenceDocument
          externalDoc={{
            url: propertyInformationReport,
            label: 'Property Information Report',
          }}
          elmId='property_information_report'
          disabled={!propertyInformationReport}
          disabledTooltip={statics.DOCUMENT_NOT_FOUND}
        />
      )
    }

    return reviewPropertyDocs
  }

  const renderPrepareForAuction = () => {
    const { note, list } = getPrepareForAuctionContent(listing, false)

    return <PrepareForAuction note={note} list={list} />
  }
  const getFinancingBody = () => {
    const financingAvailableText = listing.listing_configuration
      ?.financing_available ? (
      <span data-elm-id='conventional_financing'>
        <Text
          className='u-mt-2'
          size={isMobile ? 'tiny' : 'large'}
          color={isMobile ? 'gray' : 'grayDark'}
        >
          You’ll need to provide a pre-qualification letter from your lender and
          proof of funds immediately following the auction. A financing
          contingency period may or may not be offered.
        </Text>
      </span>
    ) : (
      <span data-elm-id='conventional_financing'>
        <Text
          size={isMobile ? 'tiny' : 'large'}
          color={isMobile ? 'gray' : 'grayDark'}
        >
          <strong>Cash</strong> is the accepted payment.{' '}
          <strong>
            In some cases, hard money loans and lines of credit are accepted.
          </strong>{' '}
          See purchase documents for details.{' '}
          <PopupTooltip
            content={
              <div>
                <Text size='tiny' color='white'>
                  Cash provides maximum flexibility. This transaction is "Cash
                  Only" for several reasons, including:
                </Text>
                <ul>
                  <li>Property is sold as-is</li>
                  <li>Seller chooses not to accept financing</li>
                  <li>No interior access to the property </li>
                  <li>No inspections or appraisals</li>
                </ul>
              </div>
            }
            position='right center'
            elmId='conventional_financing_tooltip'
            trigger={<a data-elm-id='conventional_financing_trigger'>Why?</a>}
          />
        </Text>
        <Text
          className='u-mt-2'
          size={isMobile ? 'tiny' : 'large'}
          color={isMobile ? 'gray' : 'grayDark'}
        >
          You'll need proof of funds within 48 hours of winning the auction.
        </Text>
        <Text
          className='u-mt-2'
          size={isMobile ? 'tiny' : 'large'}
          color={isMobile ? 'gray' : 'grayDark'}
        >
          Conventional financing cannot be used to buy this property.
        </Text>
      </span>
    )

    switch (listing.listing_configuration?.asset_type) {
      case graph.enums.AssetType.Foreclosure:
        return renderPrepareForAuction()
      case graph.enums.AssetType.PrivateSeller:
        return getPrivateSellerFinancingBody()
      default:
        return financingAvailableText
    }
  }

  const getPrivateSellerFinancingBody = () => {
    if (listing.listing_configuration?.financing_available) {
      return (
        <div>
          <Text
            size={isMobile ? 'tiny' : 'large'}
            color={isMobile ? 'gray' : 'grayDark'}
          >
            <strong>Getting a mortgage? Two quick steps to be ready:</strong>
          </Text>
          <ul>
            <li>
              Get a pre-approval letter from your lender (shows you can get the
              loan).
            </li>
            <li>Show proof you have the down payment saved.</li>
          </ul>
          <Text
            size={isMobile ? 'tiny' : 'large'}
            color={isMobile ? 'gray' : 'grayDark'}
          >
            <strong>Paying cash? Here’s what you’ll need:</strong>
          </Text>
          <ul>
            <li>Show a recent bank statement or similar document.</li>
            <li>
              Just needs to confirm you have the purchase amount available.
            </li>
            <li>This lets us submit your offer right away.</li>
            <li>Quick and straightforward process.</li>
          </ul>
        </div>
      )
    } else {
      return (
        <div>
          <Text
            size={isMobile ? 'tiny' : 'large'}
            color={isMobile ? 'gray' : 'grayDark'}
          >
            <strong>Paying cash? Here’s what you’ll need:</strong>
          </Text>
          <ul>
            <li>Show a recent bank statement or similar document.</li>
            <li>
              Just needs to confirm you have the purchase amount available.
            </li>
            <li>This lets us submit your offer right away.</li>
            <li>Quick and straightforward process.</li>
          </ul>
        </div>
      )
    }
  }
  const dueDiligenceContent = () => {
    // TODO - We know about missing PrivateSeller at the moment. We will come back and fix it.
    const LOB = isNotFCL(listing) ? 'REO' : 'TPS'

    return (
      <div className={cx('content')}>
        <Text
          color='gray'
          size={isMobile ? 'tiny' : 'large'}
          className={cx('u-mb-6')}
        >
          {DUE_DILIGENCE_CONTENT_MAP.DUE_DILIGENCE_BODY}
        </Text>
        <DueDiligenceItem
          icon='search-location'
          elmId='property_information'
          title='Review Property Information'
          text={DUE_DILIGENCE_CONTENT_MAP.DUE_DILIGENCE_STEP_ONE_BODY}
          sections={getPropertyDocs()}
        />
        <DueDiligenceItem
          icon='file-certificate'
          elmId='title_information'
          title='Examine Title and Liens'
          text={DUE_DILIGENCE_CONTENT_MAP[`DUE_DILIGENCE_STEP_TWO_BODY_${LOB}`]}
          sections={getTitleReports()}
        />
        <DueDiligenceItem
          icon='file-invoice-dollar'
          elmId='purchase_agreement_information'
          title={
            DUE_DILIGENCE_CONTENT_MAP[
              `DUE_DILIGENCE_STEP_THREE_SUBTITLE_${LOB}`
            ]
          }
          text={
            DUE_DILIGENCE_CONTENT_MAP[`DUE_DILIGENCE_STEP_THREE_BODY_${LOB}`]
          }
          sections={getPurchaseAgreements()}
        />
        <DueDiligenceItem
          icon='usd-circle'
          elmId='prepare_your_finances'
          title={
            DUE_DILIGENCE_CONTENT_MAP[`DUE_DILIGENCE_STEP_FOUR_SUBTITLE_${LOB}`]
          }
          text={getFinancingBody()}
          ad={<div data-ad-space={`PDP_FINANCING_${LOB}`} />}
        />
      </div>
    )
  }

  return (
    <TutorialTooltip
      elmId='due_diligence_tutorial_tooltip'
      offset={240}
      tutorial={6}
      nextButtonContent={`Let's Get Started`}
      handleNext={() => toggleAuthModal('signup')}
      skip={isPropertyReportAvailable}
      header='Do Your Research'
      content='Sign up to download property information and title report.'
    >
      <div className={cx('diligence-section-container')}>
        <SectionPanel elmId='due_diligence' title='Due Diligence'>
          <div className={cx('due-diligence')}>{dueDiligenceContent()}</div>
        </SectionPanel>
      </div>
    </TutorialTooltip>
  )
}

// TODO: have to type redux store and everything redux related
// @ts-ignore-start
const mapStateToProps = (store: any): MapStateToProps => ({
  /* eslint-disable */
  featureFlags: store.featureFlags,
  propertyInformationReport: store.propertyAnalytics.propertyInformationReport,
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
  hidePIR: store.propertyAnalytics.realtyTrackReport.hidePIR,
})

export default connect(mapStateToProps)(withModalHooks(DueDiligence))
// @ts-ignore end untyped redux
/* eslint-enable */
